var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSparkles = function SvgSparkles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sparkles-paint0_linear_5938_275803)",
    fillOpacity: 0.8,
    d: "M7.468 11.649a1.5 1.5 0 0 0-1.08-1.08l-4.61-1.19a.376.376 0 0 1 0-.722l4.61-1.19a1.5 1.5 0 0 0 1.08-1.079l1.189-4.61a.376.376 0 0 1 .724 0l1.188 4.61a1.5 1.5 0 0 0 1.08 1.08l4.61 1.188a.376.376 0 0 1 0 .724l-4.61 1.189a1.5 1.5 0 0 0-1.08 1.08l-1.19 4.61a.375.375 0 0 1-.723 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sparkles-paint1_linear_5938_275803)",
    fillOpacity: 0.8,
    d: "M15.03 2.255V5.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sparkles-paint2_linear_5938_275803)",
    fillOpacity: 0.8,
    d: "M16.534 3.758h-3.006Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sparkles-paint3_linear_5938_275803)",
    fillOpacity: 0.8,
    d: "M3.006 12.776v1.503Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sparkles-paint4_linear_5938_275803)",
    fillOpacity: 0.8,
    d: "M3.758 13.527H2.255Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#sparkles-paint5_linear_5938_275803)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.8,
    strokeWidth: 0.873,
    d: "M15.03 2.255V5.26m1.504-1.503h-3.006M3.005 12.776v1.503m.752-.752H2.255m5.213-1.878a1.5 1.5 0 0 0-1.08-1.08l-4.61-1.19a.376.376 0 0 1 0-.722l4.61-1.19a1.5 1.5 0 0 0 1.08-1.079l1.189-4.61a.376.376 0 0 1 .724 0l1.188 4.61a1.5 1.5 0 0 0 1.08 1.08l4.61 1.188a.376.376 0 0 1 0 .724l-4.61 1.189a1.5 1.5 0 0 0-1.08 1.08l-1.19 4.61a.375.375 0 0 1-.723 0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sparkles-paint0_linear_5938_275803",
    x1: 1.504,
    x2: 19.739,
    y1: 1.669,
    y2: 9.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#48C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#90FCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#E297FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sparkles-paint1_linear_5938_275803",
    x1: 1.504,
    x2: 19.739,
    y1: 1.669,
    y2: 9.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#48C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#90FCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#E297FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sparkles-paint2_linear_5938_275803",
    x1: 1.504,
    x2: 19.739,
    y1: 1.669,
    y2: 9.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#48C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#90FCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#E297FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sparkles-paint3_linear_5938_275803",
    x1: 1.504,
    x2: 19.739,
    y1: 1.669,
    y2: 9.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#48C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#90FCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#E297FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sparkles-paint4_linear_5938_275803",
    x1: 1.504,
    x2: 19.739,
    y1: 1.669,
    y2: 9.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#48C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#90FCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#E297FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sparkles-paint5_linear_5938_275803",
    x1: 1.02,
    x2: 20.013,
    y1: 0.702,
    y2: 8.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#90FCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076B6"
  })))));
};
export default SvgSparkles;